export const MDF_APPROVAL_REQUEST = "MDF_APPROVAL_REQUEST";
export const MDF_APPROVAL_SUCCESS = "MDF_APPROVAL_SUCCESS";
export const MDF_APPROVAL_FAILED = "MDF_APPROVAL_FAILED";
